import { StyledReactSelect } from '@fountain/fountain-ui-components';
import { Grid } from '@material-ui/core';
import { produce } from 'immer';
import React, { FC, useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';

import {
  everifyCaseStatusesHash,
  getConditionErrorMessage,
} from 'containers/WorkflowEditor/components/Rules/Condition/constants';
import { messages as conditionMessages } from 'containers/WorkflowEditor/components/Rules/Condition/messages';
import { RulesEditDataContext } from 'containers/WorkflowEditor/contexts/rulesEditDataContext';

import { RulesProps, SharedConditionProps } from '../../types';

export const EverifyCaseStatus: FC<SharedConditionProps> = ({
  condition,
  ruleId,
  setRules,
  setDocumentSigningRules,
  errors,
}) => {
  const intl = useIntl();

  const { extra } = condition;

  const { condition_statuses: conditionStatuses } =
    useContext(RulesEditDataContext);

  const statusLabels = everifyCaseStatusesHash(intl);

  const statusOptions = conditionStatuses?.everify?.case_status?.map(
    caseStatus => ({
      label: statusLabels[caseStatus],
      value: caseStatus,
    }),
  );

  const sortedCaseStatusOptions = useMemo(
    () => statusOptions?.sort((a, b) => a.label.localeCompare(b.label)),
    [statusOptions],
  );

  const selectedCaseStatus =
    statusOptions?.find(
      option => option.value === extra.everify?.case_status,
    ) ?? null;

  const onChangeSelection = (newSelection: {
    label: string;
    value: string;
  }) => {
    const rulesSetter = setRules ?? setDocumentSigningRules;

    if (rulesSetter) {
      rulesSetter(
        produce((draftRules: RulesProps) => {
          const draftConditions =
            draftRules[ruleId]?.condition_set_attributes
              ?.conditions_attributes ?? [];
          const idx = draftConditions.findIndex(
            cond => cond.id === condition.id,
          );

          draftConditions[idx].extra = {
            everify: { case_status: newSelection.value },
          };
        }),
      );
    }
  };

  const caseStatusErrorMessage =
    !extra.everify?.case_status &&
    getConditionErrorMessage('caseStatus', errors);

  return (
    <Grid item xs={6}>
      <StyledReactSelect
        options={sortedCaseStatusOptions}
        label={intl.formatMessage(conditionMessages.caseStatus)}
        aria-label={intl.formatMessage(conditionMessages.caseStatus)}
        onChange={onChangeSelection}
        value={selectedCaseStatus}
        error={caseStatusErrorMessage}
        placeholder=""
        required
      />
    </Grid>
  );
};
